export const company = {
   name: "draft properties",
   domain: "https://app.draft.properties",
   contactEmail: "office@draft.properties",
   supportEmail: "support@draft.properties",
   address1: {
      en: "Mladost district, Mladost 2, bl. 203, ap. 125",
      bg: 'р-н "Младост", ж.к. "Младост 2", бл. 203, ап. 125',
   },
   address2: {
      en: "Sofia 1799, Bulgaria",
      bg: "София 1799, България",
   },
   city: {
      en: "Sofia",
      bg: "София",
   },
   postalCode: 1799,
   legalName: {
      en: "Medix Manager VCC",
      bg: "Медикс Мениджър ДПК",
   },
   uic: "208140807",
   vatNumber: "BG208140807",
   ownerCompany: {
      name: "polywize",
      websiteUrl: "https://polywize.com",
   },
} as const;
